<template>
  <div>
    <common-dialog ref="dialog" width="700px" unit="会员信息" edit-title id-key="RecordId" :data="data"
      :get-data-func="api.info" :form-rules="rules" :save-func="api.save" @create-opened="onCreateOpened"
      @edit-opened="onEditOpened" :before-save="onBeforeSave" close-on-saved form-label-width="100px"
      @close-saved="$emit('close-saved')" @closed="onClosed"  >
      <template slot="form">
       
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="会员姓名" prop="PersonName">
               {{ data.PersonName }}
            </el-form-item>
          </el-col>

           <el-col :span="isMB ? 24 : 12">
            <el-form-item label="商品名称" prop="GoodsName">
                 {{ data.GoodsName }}
            </el-form-item>
          </el-col>
         </el-row>

         <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="订单编号" prop="OrderNo">
                {{ data.OrderNo }}
            </el-form-item>
          </el-col>
           <el-col :span="isMB ? 24 : 12">
            <el-form-item label="评论时间" prop="CommentTime">
                {{ data.CommentTime }}
            </el-form-item>
          </el-col>
         </el-row>

          <el-row> 
           <el-col :span="24">
            <el-form-item label="评论内容" prop="CommentNotes">
                  {{ data.CommentNotes }}
            </el-form-item>
            </el-col>
           
          </el-row>
          
      </template>
      <template #footer >
           <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
    
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";


export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
 
  },
  props: {
   
  },
  computed: {
    
  },
  data() {
    return {
      data: {
        
        PersonName: "",
        GoodsName: "",
        OrderNo:  "",  
        CommentTime: "",
        CommentNotes: "",
              
      },
     
      api: require("@/api/person/personcomment").default,
    
    };
  },
  methods: {
    onCreateOpened(data) {
     
      
    },
    onEditOpened(data) {
      
    },
    getOption() {
     
    },
          
   
  },
};
</script>

